import React from 'react';
import * as UIcons from '@iconscout/react-unicons';
import { useSelector, useDispatch } from 'react-redux';
import { previewModal } from 'store/slices/miscSlice';

export default function PreviewModal() {
  const { previewModal: {state, data} } = useSelector(state => state.misc);
  const dispatch = useDispatch();

  const Content = data?.content;
  const Title = data?.title;

  return (
    <>
      {
        !state ? (
          <></>
        ) : (
          <div className={`bg-black fixed top-0 left-0 bg-opacity-30 flex z-50 w-screen h-screen`}>
            <div className="lg:max-w-md rounded-xl lg:w-full w-11/12 bg-white text-placeholder pb-5 m-auto h-auto overflow-hidden">
              <div className="relative p-3">
                {
                  typeof(Title) === 'string' ? (
                    <h3 className="text-xl text-center text-secondary font-semibold w-full">{data?.title}</h3>
                  ) : (
                    <Title />
                  )
                }
                
                <UIcons.UilTimes 
                  className="absolute top-2 right-2 text-placeholder text-3xl cursor-pointer" 
                  onClick={() => dispatch(previewModal('close'))}
                />
              </div>

              <ul className="overflow-x-hidden h-full">
                <Content />
              </ul>
            </div>
          </div>
        )
      }
    </>
  )
}
